// extracted by mini-css-extract-plugin
export default {"container":"pR-z","modal":"qR-z","dimensions":"rR-z","brandName":"sR-z","productName":"tR-z","labelValue":"uR-z","recipientEmail":"vR-z","recommendedFit":"wR-z","hiddenField":"xR-z"};